import React from 'react';
import { Button } from 'react-bootstrap';

const JianyingTaskFooter = ({
  activeMaterialType,
  clientName,
  loading,
  materialTypes,
  onChangeMaterialType,
  onChangeOrder,
  onChangeTemplate,
  onCreate,
  orderId,
  selectedTemplate,
  selectedTemplateAvailable,
  submitButtonLabel,
  submitting,
}) => (
  <section
    className="jianying-task-steps"
    aria-label="任务创建步骤"
  >
    <div
      className={`jianying-task-step ${orderId ? 'is-complete' : 'is-active'}`}
      aria-current={!orderId ? 'step' : undefined}
    >
      <div className="jianying-task-step__node">
        {orderId ? <i className="bi bi-check-lg" /> : '1'}
      </div>
      <span className="jianying-task-step__label">订单</span>
      <div className="jianying-task-step__card is-compact">
        <strong>{orderId ? clientName : '尚未选择'}</strong>
        <button
          type="button"
          disabled={submitting}
          onClick={onChangeOrder}
        >
          {orderId ? '更改' : '选择'}
        </button>
      </div>
    </div>

    <div
      className={`jianying-task-step ${selectedTemplate ? 'is-complete' : orderId ? 'is-active' : ''}`}
      aria-current={orderId && !selectedTemplate ? 'step' : undefined}
    >
      <div className="jianying-task-step__node">
        {selectedTemplate ? <i className="bi bi-check-lg" /> : '2'}
      </div>
      <span className="jianying-task-step__label">模板</span>
      <div className="jianying-task-step__card is-compact">
        <strong>{selectedTemplate?.name || '尚未选择'}</strong>
        <button
          type="button"
          disabled={!orderId || loading || submitting}
          onClick={onChangeTemplate}
        >
          {selectedTemplate ? '更改' : '选择'}
        </button>
      </div>
    </div>

    <div
      className={`jianying-task-step ${submitting ? 'is-complete' : selectedTemplate ? 'is-active' : ''}`}
      aria-current={selectedTemplate && !submitting ? 'step' : undefined}
    >
      <div className="jianying-task-step__node">3</div>
      <span className="jianying-task-step__label">素材配置</span>
      <nav className="jianying-task-step__card jianying-material-switch" aria-label="素材类型">
        {materialTypes.map((item) => (
          <button
            key={item.key}
            type="button"
            className={activeMaterialType === item.key ? 'is-active' : ''}
            disabled={!selectedTemplate || submitting}
            onClick={() => onChangeMaterialType(item.key)}
            aria-label={item.label}
            aria-pressed={activeMaterialType === item.key}
            title={item.label}
          >
            <i className={`bi ${item.icon}`} aria-hidden="true" />
            <span>{item.label}</span>
          </button>
        ))}
      </nav>
    </div>

    <div
      className={`jianying-task-step ${submitting ? 'is-active' : ''}`}
      aria-current={submitting ? 'step' : undefined}
    >
      <div className="jianying-task-step__node">4</div>
      <span className="jianying-task-step__label">创建任务</span>
      <div className="jianying-task-step__card is-create">
        <Button
          className="jianying-primary-action"
          disabled={submitting || !selectedTemplateAvailable}
          onClick={onCreate}
        >
          {submitButtonLabel}
        </Button>
      </div>
    </div>
  </section>
);

export default JianyingTaskFooter;
